<template>
  <div >
    <v-carousel v-model="model" cycle class="pointer">
      <v-carousel-item  v-for="(slide, index) in items" :key="index">
        <v-sheet color="primary" height="100%" tile @click="$emit('on-click',slide)">
          <v-row class="fill-height" align="center" justify="center">
            <v-img :src="image_link"> </v-img>
          </v-row>
        </v-sheet>
      </v-carousel-item>
    </v-carousel>
    <div class="primary slider_comment" v-show="items.length > 0">
      <div class="text-center" :key="next_slide_key">{{ slide_comment }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Slider",
  props: {
    items: {
      type: Array,
      default: () => {
        return [];
      },
    },
    model_control: {
      type: [String,Number],
      default: -1
    },
  },
  data: () => {
      return {
          image_link: require("../assets/login_bg.png"),
          model: 0,
        next_slide_num: 0,
        next_slide_key: "next_slide_key_0"
      }
  },
  watch:{
    model_control: function(val){
        // console.log("This has changed to ", val);
        this.model = parseInt(val);
        this.next_slide_num  = this.next_slide_num + 1;
        this.next_slide_key = "next_slide_key_" + this.next_slide_num;
    }
  },
  computed: {
    slide_comment() {
      var text = "";
      for (var index = 0; index < this.items.length; index++) {
        var item = this.items[index];
        if (parseInt(this.model) == index) {
          text = item.comment;
          break;
        }
      }
      return text;
    },
  },
};
</script>